import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "viewBox", "color", "focusable", "children", "className", "__css"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// ../../../react-shim.js
import React from "react";

// src/icon.tsx
import { chakra, forwardRef } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
var fallbackIcon = {
  path: /* @__PURE__ */React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  }, /* @__PURE__ */React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }), /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }), /* @__PURE__ */React.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  })),
  viewBox: "0 0 24 24"
};
var Icon = forwardRef(function (props, ref) {
  var element = props.as,
    viewBox = props.viewBox,
    _props$color = props.color,
    color = _props$color === void 0 ? "currentColor" : _props$color,
    _props$focusable = props.focusable,
    focusable = _props$focusable === void 0 ? false : _props$focusable,
    children = props.children,
    className = props.className,
    __css = props.__css,
    rest = _objectWithoutProperties(props, _excluded);
  var _className = cx("chakra-icon", className);
  var styles = _objectSpread({
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: color
  }, __css);
  var shared = {
    ref: ref,
    focusable: focusable,
    className: _className,
    __css: styles
  };
  var _viewBox = viewBox !== null && viewBox !== void 0 ? viewBox : fallbackIcon.viewBox;
  if (element && typeof element !== "string") {
    return /* @__PURE__ */React.createElement(chakra.svg, _objectSpread(_objectSpread({
      as: element
    }, shared), rest));
  }
  var _path = children !== null && children !== void 0 ? children : fallbackIcon.path;
  return /* @__PURE__ */React.createElement(chakra.svg, _objectSpread(_objectSpread({
    verticalAlign: "middle",
    viewBox: _viewBox
  }, shared), rest), _path);
});
Icon.displayName = "Icon";
var icon_default = Icon;

// src/create-icon.tsx
import { forwardRef as forwardRef2 } from "@chakra-ui/system";
import { Children } from "react";
function createIcon(options) {
  var _options$viewBox = options.viewBox,
    viewBox = _options$viewBox === void 0 ? "0 0 24 24" : _options$viewBox,
    pathDefinition = options.d,
    displayName = options.displayName,
    _options$defaultProps = options.defaultProps,
    defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps;
  var path = Children.toArray(options.path);
  var Comp = forwardRef2(function (props, ref) {
    return /* @__PURE__ */React.createElement(Icon, _objectSpread(_objectSpread({
      ref: ref,
      viewBox: viewBox
    }, defaultProps), props), path.length ? path : /* @__PURE__ */React.createElement("path", {
      fill: "currentColor",
      d: pathDefinition
    }));
  });
  Comp.displayName = displayName;
  return Comp;
}
export { Icon, createIcon, icon_default as default };